import { HttpParams } from '@angular/common/http'
import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import {
    BaseComponent,
    FabJob,
    FabPiece,
    FabShopFloor,
    FabShopFloorLane,
    FabStampStepRequest,
    FeatureType,
    ListItem,
    replaceListItemsIfChanged,
} from '../../shared'

@Component({
    selector: 'app-fab-shop-floor',
    templateUrl: './fab-shop-floor.component.html',
    styleUrls: ['./fab-shop-floor.component.css'],
    standalone: true,
    imports: [FormsModule, WjInputModule],
})
export class FabShopFloorComponent extends BaseComponent {
    jobs: FabJob[] = []
    jobOptions: ListItem<string>[] = []
    selectedJobId = ''
    private appliedJobId = ''
    lanes: FabShopFloorLane[] = []
    stampingPieceId: string | null = null

    constructor() {
        super()
        this.refresh()
    }

    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.FabShopFloorEdit])
    }

    onJobChanged() {
        if (this.selectedJobId === this.appliedJobId) return
        this.refresh(false)
    }

    refresh(showSpinner = true) {
        const requestedJobId = this.selectedJobId
        let params = new HttpParams()
        if (requestedJobId) {
            params = params.set('fabJobId', requestedJobId)
        }

        this.cancelableRequest(
            '',
            showSpinner,
            this.services.data.load(showSpinner, showSpinner, this.services.data.get<FabShopFloor>('api/FabViews/ShopFloor', params)).subscribe({
                next: result => {
                    this.initialLoadingComplete()
                    const view = result[0]
                    this.jobs = view.jobs || []
                    this.lanes = view.lanes || []
                    this.jobOptions = replaceListItemsIfChanged(this.jobOptions, [
                        new ListItem('', '(All jobs)'),
                        ...this.jobs.map(j => new ListItem(j.id, j.displayName || j.jobDescription || j.name || '')),
                    ])
                    this.appliedJobId = requestedJobId
                    if (this.selectedJobId !== requestedJobId) {
                        this.selectedJobId = requestedJobId
                    }
                },
            }),
        )
    }

    completeNextStep(piece: FabPiece) {
        if (!this.canEdit || !piece.nextStepId || this.stampingPieceId) return

        this.stampingPieceId = piece.id
        const body: FabStampStepRequest = {
            fabPieceId: piece.id,
            fabProcessStepId: piece.nextStepId,
            actualDate: new Date(),
            clear: false,
            note: null,
        }

        this.services.data.post('api/FabViews/StampStep', body).subscribe({
            next: () => {
                this.stampingPieceId = null
                this.refresh(false)
            },
            error: () => {
                this.stampingPieceId = null
                this.services.notification.error('Failed to complete step.')
            },
        })
    }

    riskClass(piece: FabPiece): string {
        if (piece.isOnHold || piece.riskLevel === 'Blocked') return 'lane-row-blocked'
        if (piece.riskLevel === 'AtRisk') return 'lane-row-atrisk'
        if (piece.riskLevel === 'DueSoon') return 'lane-row-duesoon'
        return ''
    }

    formatDate(value: Date | string | null | undefined): string {
        if (!value) return '—'
        const d = new Date(value)
        if (isNaN(d.getTime())) return '—'
        return d.toISOString().slice(0, 10)
    }
}
